// Generated by IcedCoffeeScript 108.0.8
(function() {
  var keccaklib;

  keccaklib = require('./keccak');

  exports.SHA3 = keccaklib.KECCAK;

  exports.transform = keccaklib.transform;

}).call(this);
